// extracted by mini-css-extract-plugin
module.exports = {"categories":"highlightedProducts_categories__8GBKn","categoryButton":"highlightedProducts_categoryButton__MSXVa","activeCategory":"highlightedProducts_activeCategory__Ywz3Y"};